import React from "react";
import notFound from "../Assets/poster-not-found.png";

const Card = (props) => {
  // console.log(props.data.data);
  // console.log(props.data.data[0]);
  const item = props.data;
  // console.log(item);

  return (
    <div className="movie-card">
      {item === false || item === undefined ? (
        <>
          <img
            className="movie-poster"
            src={notFound}
            alt={`movie poster not found`}
          />
          <h2 className="movie-title">Title not found</h2>
          <p className="movie-plot">Plot not found</p>
          <p className="movie-release">Release date not found</p>
        </>
      ) : (
        <>
          <img
            className="movie-poster"
            src={item.Poster}
            alt={`${item.Title} movie poster`}
          />
          <h2 className="movie-title">{item.Title}</h2>
          <p className="movie-plot">{item.Plot}</p>
          <p className="movie-release">{item.Released}</p>
        </>
      )}
    </div>
  );
};

export default Card;
